import { render } from "./CharlaHowItWork.vue?vue&type=template&id=a05a4578&scoped=true"
import script from "./CharlaHowItWork.vue?vue&type=script&lang=js"
export * from "./CharlaHowItWork.vue?vue&type=script&lang=js"

import "./CharlaHowItWork.vue?vue&type=style&index=0&id=a05a4578&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a05a4578"]])

export default __exports__